import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: theme.typography.fontWeightRegular,
        },
    })
);

export default function SimpleAccordion() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1a-content'
                    id='panel1a-header'
                >
                    <Typography className={classes.heading}>
                        <GetAppIcon /> Download DYL Editor App (Windows Only)
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <Link
                                    href='https://github.com/dim0147/DYLEditorApplication/releases/'
                                    target='_blank'
                                >
                                    <GetAppIcon /> Download DYL Editor App
                                </Link>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                        <Typography>
                                - This app is desktop application.
                            </Typography>
                            <Typography>
                                - This app is under DYL Download Facebook Video
                                extension on chrome store.
                            </Typography>
                            <Typography>
                                - This will help you render video with duration
                                bigger than 1 hour.
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Click download and goto the download page,
                                click on 'DYL_setup.exe' and download the file:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/1.jpeg`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - In some browser, it will show some message
                                that said this file is virus, ignore it:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/2.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Open and install the setup, it will display a
                                screen like this notify you prevent install
                                unknown app, skip it:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/3.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/4.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Run the setup and install, after install
                                success run the application:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/5.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - The app will be like this:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/6.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Back to web page, copy DYL Editor URL From
                                Web:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/7.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Paste DYL Editor URL From Web To App:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/8.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Name the file you want when render success and
                                press 'START' button it will start download
                                video and audio then render the video, NOTE: if
                                the file render exist already it will ask you
                                choose another name:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='center' mb={3}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/AppDesktop/9.png`}
                                    alt=''
                                    width='100%'
                                    height='auto'
                                    crossOrigin='anonymous'
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>
                                - Virus checking result by Virus Total:{' '}
                                <Link
                                    href='                 
                        https://www.virustotal.com/gui/file/4b8e8ce1875c4eab944b3b7b8dc1b3e3ef3e4996fa0670587bb12855000bec50/detection

'
                                    target='_blank'
                                >
                                    Virus Total
                                </Link>
                            </Typography>
                        </Grid>

                        <Grid item xs={12}></Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
